<template>
    <div>
        <div class="" v-if="isGuestMode">
            <ul class="guest">
                <li class="guest"
                    v-for="(lang, index) in languages" :key="`lang${index}`">
                    <a href="javascript:void(0)"
                       :class="['text-capitalize', isActive(lang.value)]"
                       v-on:click="changeLanguage(lang)">
                        {{ lang.title }}
                    </a>
                </li>
            </ul>
        </div>
        <div v-else class="d-inline">
            <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none btn btn-sm icon icon-light mr-3"
                        no-caret>
                <template v-slot:button-content >
                    <span class="font-weight-bold">
                        {{current | toUpper}}
                    </span>
                </template>
                <b-dropdown-item
                        variant="custom-active"
                        class="text-capitalize"
                        v-for="lang in languages" :key="lang.value"
                        :active="isActive(lang.value)"
                        v-on:click="changeLanguage(lang)">
                    {{ lang.title }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
    import {EVENT_LANG_CHANGE, EVENT_LANG_CHANGE_SIDEBAR} from "@/core/constants";

    export default {
        name: "LanguagePicker",
        props: {
            guest: Boolean
        },
        created() {
            this.$store.getters["langStore/supported"].forEach(item => {
                this.languages.push({
                    value: item,
                    title: this.$t('languages')[item]
                });
            });
        },
        data() {
            return {
                isGuestMode: this.guest,
                languages: []
            }
        },
        methods: {
            changeLanguage(lang) {
                let loader = this.$loading.show();
                setTimeout(() => {
                    let old = this.$i18n.locale;
                    this.$i18n.locale = lang.value;
                    this.$store.dispatch('langStore/setLanguage', lang.value)
                        .then(() => {
                            this.$eventBus.$emit(EVENT_LANG_CHANGE, {
                                oldValue: old,
                                newValue: this.$i18n.locale
                            });
                            this.$eventBus.$emit(EVENT_LANG_CHANGE_SIDEBAR, {
                                oldValue: old,
                                newValue: this.$i18n.locale
                            });
                        })
                        .finally(() => {
                            loader.hide();
                            loader = null;
                        });
                }, 500);
            },

            isActive(lang) {
                if (this.isGuestMode) {
                    return lang === this.current ? 'active' : '';
                }
                return lang === this.current;
            },
        },

        computed: {
            current: function () {
                return this.$store.getters["langStore/current"];
            }
        },

        filters: {
            upperCase(val) {
                return val.toUpperCase();
            }
        }
    }
</script>

<style scoped>
    .guest ul {
        list-style: none;
    }

    .guest li {
        display: inline;
        margin-left: 15px;
        margin-right: 15px;
    }

    .active {
        background: transparent !important;
        color: #b89453 !important
    }

    .dropdown-item.active {
        background: transparent !important;
        color: #b89453 !important
    }



</style>
